import { Box } from "@mui/material";
import OutlinedButton from "../../components/buttons/OutlinedButton";
import { ReactComponent as mailSVG } from "../../icons/icon_files/mail_24.svg";
import { ReactComponent as BreezeLogoDisabled } from "../../scenes/stack/environment/icons/breeze_logo_disabled.svg";
import { ReactComponent as BreezeLogo } from "../../scenes/stack/environment/icons/sidebar_icons/side-bar-logo-collapsed.svg";

export default function OutlinedButtonDemo() {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" gap={2} alignItems="center">
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={mailSVG}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={mailSVG}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={mailSVG}
          loading={true}
        />
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton onClick={() => {}} color="inherit" size="xs">
          Extra small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={mailSVG}
        >
          Extra small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={mailSVG}
          disabled={true}
        >
          Extra small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={mailSVG}
          loading={true}
        >
          Extra small
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={mailSVG}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={mailSVG}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={mailSVG}
          loading={true}
        />
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton onClick={() => {}} color="inherit" size="small">
          Small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={mailSVG}
        >
          Small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={mailSVG}
          disabled={true}
        >
          Small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={mailSVG}
          loading={true}
        >
          Small
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={mailSVG}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={mailSVG}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={mailSVG}
          loading={true}
        />
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton onClick={() => {}} color="inherit" size="medium">
          Medium
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={mailSVG}
        >
          Medium
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={mailSVG}
          disabled={true}
        >
          Medium
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={mailSVG}
          loading={true}
        >
          Medium
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={mailSVG}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={mailSVG}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={mailSVG}
          loading={true}
        />
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton onClick={() => {}} color="inherit" size="large">
          Large
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={mailSVG}
        >
          Large
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={mailSVG}
          disabled={true}
        >
          Large
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={mailSVG}
          loading={true}
        >
          Large
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          xs
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="xs"
          disabled={true}
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          xs
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          Small
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="small"
          disabled={true}
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          Small
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          Medium
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="medium"
          disabled={true}
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          Medium
        </OutlinedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center" mb={4}>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
          disabled={true}
        />
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          Large
        </OutlinedButton>
        <OutlinedButton
          onClick={() => {}}
          color="inherit"
          size="large"
          disabled={true}
          icon={BreezeLogo}
          disabledIcon={BreezeLogoDisabled}
        >
          Large
        </OutlinedButton>
      </Box>
    </Box>
  );
}
